<template>
	<div id="app-cke" @mouseleave="mouseLeave">
    	<vue-ckeditor 
    		:id="`myQuillEditor_${position}`"
	      	v-model="content" 
	      	:config="config" 
	      	@blur="onBlur($event)" 
	      	@focus="onFocus($event)"
	    />
	    <b-modal :id="`modal_upload_q_${position}`" hide-footer>
	    	<template v-slot:modal-title>
	    		Tải lên media
	    	</template>
	    	<div class="d-block text-center">
	    		<div class="form-group">
			    	<label class="display-block font-weight-bold">Tải {{typeUpload === 'image' ? 'ảnh' : 'media'}} thông qua link</label>
			    	<input type="text" class="form-control full-width" ref="link_media">
		    	</div>
		    	<p class="display-block text-center full-width hr-center position-rel">
		    		<span class="position-rel">Hoặc</span>
		    	</p>
		    	<div class="form-group form-editor-media position-rel text-center display-flex-center justify-content-center">
		    		<span class="margin-0">Tải lên {{typeUpload === 'image' ? 'ảnh' : 'media'}}</span>
		    		<input v-if="typeUpload === 'image'" type="file" name="" id="upImg" ref="upImg" @change="uploadImage" accept="image/*">
					<input 
						v-else
						type="file" 
						ref="upMedia" 
						@change="uploadMedia" 
						:accept="typeUpload === 'video' ? 'video/mp4,video/x-m4v,video/*' : 'audio/*'"
					>
		    	</div>
	    	</div>
	    </b-modal>
    </div>
</template>

<script>
	import VueCkeditor from 'vue-ckeditor2';
	// import mixins from '@/helpers/mixins';
	import { CHANGE_TXT_QUESTION } from '@/store/common/constants';
	import { mapGetters, mapActions } from 'vuex';
	import { replaceHtmlMathlive, setAlignImgEditor, fillBlankEditor, convertOldKatexData2Img } from '@/helpers/functions';
	import { uploadImg } from '@/store/common/api';
	import { APP_CONFIG } from '@/utils/constants'
	// const imgVideo = require('@/assets/images/video.png')
	// const imgAudio = require('@/assets/images/audio.png')
	// const imgFx = require('@/assets/images/fx.png')
	// const imgDraw = require('@/assets/images/draw.png')
	CKEDITOR.plugins.addExternal('ckeditor_wiris', '/libs/mathtype/plugin.js');

	if(!CKEDITOR.plugins.get('niw_btn')) {
		CKEDITOR.plugins.add('niw_btn', {
		    init: function(editor) {
		        // Button drawshape
		        // editor.ui.addButton('drawShape', {
	         //        label: 'Vẽ hình',
	         //        command: 'drawShape',
	         //        icon: 'https://hoc24.vn/media/cke24/plugins/svgedit/icons/svgedit.png?t=14',
	         //        toolbar: 'insert'
	         //    });

				// Button upload img
				editor.ui.addButton('uploadImg', {
	                label: 'Tải hình ảnh',
	                command: 'uploadImg',
	                icon: 'https://hoc24.vn/media/cke24/plugins/imgur/images/icon.png?t=14',
	                toolbar: 'insert'
	            });

				// Button upload Video
				editor.ui.addButton('uploadVideo', {
	                label: 'Tải video',
	                command: 'uploadVideo',
	                icon: 'https://image.flaticon.com/icons/svg/60/60813.svg',
	                toolbar: 'insert'
	            });

				// Button upload Audio
				editor.ui.addButton('uploadAudio', {
	                label: 'Tải audio',
	                command: 'uploadAudio',
	                icon: 'https://image.flaticon.com/icons/svg/126/126508.svg',
	                toolbar: 'insert'
	            });
		    }
		});
	}

	export default {
		name: 'EditorCK',
		// mixins: [mixins],
		props: ['contentEditor', 'fillBlank', 'position', 'selectBox', 'toolbar', 'editorHeight'],
		data () {
			return {
				content: '',
				editor: null,
				typeUpload: '',
		        visibleModalMedia: false,
		       	linkMediaUploaded: '',
				config: {
					toolbar: [
          	{ name: 'document', items: [ 'Source'] },
          	{ name: 'styles', items: [ 'Format', 'Font', 'FontSize' ] },
						{ name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat' ] },
						{ name: 'colors', items: [ 'TextColor', 'BGColor' ] },
						{ name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'] },
						{ name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
						{ name: 'insert', items: [ 'Media', 'uploadImg', 'uploadVideo', 'uploadAudio', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe', 'ckeditor_wiris_formulaEditor','ckeditor_wiris_formulaEditorChemistry' ] },
			        ],
			        height: 200,
			        extraPlugins: 'niw_btn,ckeditor_wiris',
    				allowedContent: true,
    				font_defaultLabel: 'Arial',
					fontSize_defaultLabel: 12,
					contentsCss: ["body {font-size: 18px; font-family: 'Arial'}"]
    				// extraAllowedContent: mathElements.join( ' ' ) + '(*)[*]{*};img[data-mathml,data-custom-editor,role](Wirisformula)'
				}
			}
		},
		components: { VueCkeditor },
		computed: {
			...mapGetters({
		      	math_value: `common/math_value`,
		      	open_math: `common/open_math`,
		      	editor_selection: 'common/editor_selection',
		      	// draw_shape_data: 'common/draw_shape_data',
		      	toggle_draw: 'common/toggle_draw',
		    }),
		},
		watch: {
			// draw_shape_data(newVal, oldVal) {
		 //    	if(newVal && newVal.type === 'question' && newVal.data && this.position === newVal.position) {
			// 	    let linkSvgBase64 = 'data:image/svg+xml;utf8,';
			// 	    	linkSvgBase64 += encodeURIComponent(newVal.data);
			// 	    // let htmlData = `<figure class="image"><img src="${linkSvgBase64}"></figure>`;
			// 	    let htmlData = `<img src="${linkSvgBase64}">`;
			// 	    CKEDITOR.instances[`myQuillEditor_${newVal.position}`].insertHtml(htmlData);
			// 		this.setDrawShapeData(null);
		 //    	}
		 //    },
			'content': 'onChangeContent',
			'contentEditor': function(){
				this.content = this.contentEditor;
			},
		},
		created() {
			// Convert old data use Katex
			// this.convertKatex2Img()
			this.content = this.contentEditor ? this.contentEditor : '';
			if(this.toolbar !== ''){
				this.config.toolbar = this.toolbar;
			}
			if(this.editorHeight > 0){
				this.config.height = this.editorHeight;
			}
		},
		mounted() {
			// All action for all button
			this.actionNiwBtn();
		},
		methods: {
			...mapActions(`common`, ['toggleFormMath', 'setContentSelectEditor', 'toggleDrawTool', 'setDrawShapeData']),

			convertKatex2Img() {
				if(this.contentEditor) {
					this.content = convertOldKatexData2Img(this.contentEditor);
				}
			},

			actionNiwBtn() {
				let self = this;
				let editor = CKEDITOR.instances[`myQuillEditor_${self.position}`];
		        // Button drawshape
	            editor.addCommand("drawShape", {
				    exec: function(edt) {
				        self.openDrawTool(self.position);
				    }
				});

				// Button upload img
	            editor.addCommand("uploadImg", {
				    exec: function(edt) {
				        self.openModalUploadMedia('image')
				    }
				});

				// Button upload Video
	            editor.addCommand("uploadVideo", {
				    exec: function(edt) {
				        self.openModalUploadMedia('video')
				    }
				});
				// Button upload Audio
	            editor.addCommand("uploadAudio", {
				    exec: function(edt) {
				        self.openModalUploadMedia('audio')
				    }
				});
			},

            onBlur(evt) {
            	this.mouseLeave()
		      	// console.log('Blur: ');
		  //     	let html = evt.editor.getData()
				// let frame = document.querySelector(`#${evt.editor.id}_contents iframe`);
				// let cntnt = frame.contentWindow.document;
				// let parag = cntnt.getElementsByTagName("p");
				// let legthParag = parag.length;
				// let contentEdit = '';
				// for(let i = 0; i < legthParag; i++) {
				// 	contentEdit += parag[i].outerHTML;
				// }
				// console.log(parag.length, contentEdit);
		      	// this.onEditorChange(evt.editor._.data)
		    },
		    onFocus(evt) {
		    	// this.mouseLeave()
		  //     	console.log('Focus: ', evt);
		  //     	// evt.editor.change();
		  //     	let frame = document.querySelector(`#${evt.editor.id}_contents iframe`);
				// let cntnt = frame.contentWindow.document;
				// let parag = cntnt.getElementsByTagName("p");
				// let legthParag = parag.length;
				// let contentEdit = '';
				// for(let i = 0; i < legthParag; i++) {
				// 	contentEdit += parag[i].outerHTML;
				// }
				// // console.log(parag.length, contentEdit, evt.editor._.data);
				// // console.log(CKEDITOR.plugins.externals.ckeditor_wiris, CKEDITOR.dialog.on('ckeditor_wiris'));
		  //     	this.onEditorChange(contentEdit)
		      	// document.getElementById("app-cke").click();

		      	// this.onEditorChange(evt.editor._.data)
		      	// this.mouseLeave()
		    },

		    mouseLeave() {
		    	// console.log('Mouse leave: ');
		    	let frame = document.querySelector(`#cke_myQuillEditor_${this.position} iframe`);
		    	if(frame){
					let cntnt = frame.contentWindow.document;
					// let parag = cntnt.getElementsByTagName("p");
					let parag = cntnt.body && cntnt.body.childNodes ? cntnt.body.childNodes : [];
					let legthParag = parag.length;
					let contentEdit = '';
					if(legthParag > 0) {
						for(let i = 0; i < legthParag; i++) {
							contentEdit += parag[i].outerHTML;
						}
					}
					// console.log('AAAAAAAAAA', parag.length, contentEdit);
					this.onEditorChange(contentEdit)
		    	}
		    },

		    onChangeContent(val) {
				let editor = CKEDITOR.instances[`myQuillEditor_${this.position}`];
				if(val == editor.getData()){
					editor && this.onEditorChange(editor._.data)
		    		editor && this.onEditorChange(editor.getData())
				}
		    },

		    onEditorChange(html) {
		    	//console.log('onchange', data);
				let data = {html, position: this.position};
				this.$bus.emit(`${CHANGE_TXT_QUESTION}_${this.position}`, data);
			},
			uploadImage(evt) {
				let self = this;
        console.log('UPload file:', evt);
				
				// const files = evt.target.files[0];
				// if (files) {
					uploadImg(evt).then(res => {
            console.log('Upload success: ', APP_CONFIG, res);
						let linkImg = `${APP_CONFIG.appUrl}/${res}`;
							// console.log('2222222222222222222222',linkImg);
    				linkImg && self.insertEmbedEditor('image', linkImg);
					})
				// }
			},

		    openMathKeyboard(editor) {
				this.toggleFormMath({visible: true, editor});
			},

			addFillBlankQuestion(type = 'blank') {
				fillBlankEditor(type, `myQuillEditor_${this.position}`);
			},

			openModalUploadMedia(type) {
				this.typeUpload = type;
				// this.visibleModalMedia = true;
				this.$bvModal.show(`modal_upload_q_${this.position}`)
			},

			insertEmbedEditor(type = 'image', link, embed = false) {
				let self = this;
				let htmlData;
				if(type === 'image') {
					htmlData = `<img src="${link}">`
				} else if (type === 'video') {
					if(embed && link.includes('youtube')) {
						htmlData = `<iframe width="560" height="315" src="${link}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
					} else if (embed && link.includes('vimeo')) {
						htmlData = `<iframe src="${link}" width="480" height="360" frameborder="0" title="My video" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`
					} else {
						htmlData = `<video width="400" controls>
									  	<source src="${link}" type="video/mp4">
									  	<source src="${link}" type="video/ogg">
									</video>`;
					}
				} else if (type === 'audio') {
					htmlData = `<audio controls>
								  	<source src="${link}" type="audio/ogg">
								  	<source src="${link}" type="audio/mpeg">
								</audio>`;
				}
				CKEDITOR.instances[`myQuillEditor_${self.position}`].insertHtml(htmlData);
				
		        if(type === 'image') {
		        	self.$refs.upImg.value = '';
		        } else {
		        	self.$refs.link_media.value = '';
					self.$refs.upMedia.value = '';
		        }
		        this.$bvModal.hide(`modal_upload_q_${this.position}`)
		        // self.visibleModalMedia = false;
			},

			uploadMedia(evt) {
				let self = this;
				// self.visibleModalMedia = false;
				// const files = evt.target.files[0];
				// console.log(files);
				// if (files) {
					uploadImg(evt).then(res => {
						// console.log(res);
						// let quill = self.$refs[`myQuillEditor_${this.position}`].quill
    					// let index = quill.getSelection() ? quill.getSelection().index : 0;
    					let linkImg = res;
    					// quill.insertEmbed(index, 'video', linkImg)
				     //    quill.setSelection(index + 1)
				     //    this.$refs.upImg.value = '';
					})
				// }
			},

			handleDoneUpload() {
				// console.log('Done: ', this.$refs);
				let linkSocial = this.$refs.link_media.value;
				let linkMedia = linkSocial;
				let embedVideo = false;
				if(linkSocial && linkSocial !== undefined) {
					if( linkSocial.includes('youtube') ) {
						let linkYT = linkSocial.split('.com/watch?v=');
		                linkMedia = linkYT[0] + '.com/embed/' + linkYT[1];
		                embedVideo = true;
					} else if ( linkSocial.includes('vimeo') ) {
						let linkVM = link.split('vimeo.com/');
	                	linkMedia = linkVM[0] + 'player.vimeo.com/video/' + linkVM[1];
	                	embedVideo = true;
					}
				} else {
					linkMedia = this.linkMediaUploaded;
				}
				console.log(linkMedia);
				
		        linkMedia && this.insertEmbedEditor(this.typeUpload, linkMedia, embedVideo);
		        // this.visibleModalMedia = false;
			},

			handleCancelUpload() {
				if(this.$refs.link_media && this.$refs.link_media.value) {
					this.$refs.link_media.value = '';
				}
				if(this.$refs.upMedia && this.$refs.upMedia.value) {
					this.$refs.upMedia.value = '';
				}
				this.$bvModal.hide(`modal_upload_q_${this.position}`)
				// this.visibleModalMedia = false;
				this.toggleFormMath({visible: false, editor: null});
			},

			openDrawTool(location) {
				this.toggleDrawTool(true);
				this.setDrawShapeData({position: location, type: 'question'});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.editor-modal-media {
		label {
			margin-bottom: 8px;
		}
		input {
			min-width: 100%;
		}
		.hr-center {
			margin: 15px 0;

			&:before {
				content: "";
				height: 1px;
				width: 60%;
				background: #ccc;
				position: absolute;
				top: 50%;
				left: 0;
				right: 0;
				margin: 0 auto;
			}

			span {
				padding: 0 20px;
				background: #fff;
			}
		}

		.form-editor-media {
			width: 120px;
		    height: 120px;
		    border: 1px solid #d1d1d1;
		    margin: 0 auto;

		    input {
		    	position: absolute;
		    	top: 0;
		    	left: 0;
		    	width: 100%;
		    	height: 100%;
		    	opacity: 0;
		    	cursor: pointer;
		    }
		}
	}
	.cke_button__uploadvideo {background: red;}
	.cke_button__uploadvideo .cke_label{display:inline;}
</style>